var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPageGroupicon = function SvgPageGroupicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 13V1.8A1.6 1.6 0 0 0 10.4.2H5.792a2.4 2.4 0 0 0-1.696.704L.704 4.296A2.4 2.4 0 0 0 0 5.992V13a1.6 1.6 0 0 0 1.6 1.6h8.8A1.6 1.6 0 0 0 12 13ZM1.6 6.6h4a.8.8 0 0 0 .8-.8v-4h4V13H1.6V6.6Zm12 8V3.4A1.6 1.6 0 0 1 15.2 5v9.6a3.2 3.2 0 0 1-3.2 3.2H4.8a1.6 1.6 0 0 1-1.6-1.6H12a1.6 1.6 0 0 0 1.6-1.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgPageGroupicon;